import { createSelector } from "reselect";
import { AppState } from "../..";

// Base selectors
const getSurveyState = (state: AppState) => state.survey;

// Memoized selectors
export const getSurvey = createSelector([getSurveyState], (survey) => survey);

export const getSurveyDetails = createSelector([getSurveyState], (survey) => survey.details);

// Specific memoized selectors for commonly used properties
export const getPositiveNote = createSelector([getSurveyState], (survey) => survey.positiveNote);

export const getNegativeNote = createSelector([getSurveyState], (survey) => survey.negativeNote);

export const getEmail = createSelector([getSurveyState], (survey) => survey.email);

export const getSurveyAvailableTags = createSelector([getSurveyDetails], (details) => details?.availableTags || []);

// Combined selector to reduce multiple useSelector calls
export const getSurveyData = createSelector(
    [getPositiveNote, getNegativeNote, getEmail],
    (positiveNote, negativeNote, email) => ({
        positiveNote,
        negativeNote,
        email,
    })
);
